/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue";
import * as axios from "axios";

export const baseUrl = process.env.VUE_APP_SERIAL_CODE_CAMPAIGN_ENDPOINT_URL;
export const redirectUrl = process.env.VUE_APP_REDIRECTOR_ENDPOINT_URL;

export const getRedirectURL = (
  redirectCode: string,
  campaignId: string,
  serialCode: string,
  transitionSrc: string
): string => {
  return `${redirectUrl}/${redirectCode}/${serialCode}?cid=${campaignId}&tran_src=${transitionSrc}`;
};

// キャンペーン開催状態取得 API
export const getState = (campaignId: string): axios.AxiosPromise<any> => {
  return Vue.$axios.get(`${baseUrl}/collection/v1/state/${campaignId}`);
};

export interface ChargeResult {
  collect_count: number;
  owned_count: number;
  point: number;
}

// シリアルコードで貯める API
export const postCollectCharge = (
  campaignId: string,
  token: string,
  serialCode: string
): axios.AxiosPromise<ChargeResult> => {
  return Vue.$axios.post(`${baseUrl}/collection/v1/collect_charge/serialcode`, {
    campaign_id: campaignId,
    token: token,
    serial_code: serialCode,
  });
};

export enum COURSE_APPLY_STATE {
  ApplyOk = "apply_ok",
  ApplyNgWonLimitOver = "apply_ng_won_limit_over",
  ApplyNgCollectionNotEnough = "apply_ng_collection_not_enough",
}

export interface CourseGroups {
  id: number;
  course_group_name: string;
  display_order: number;
  group_won_limit: number;
  course_group_apply_state: COURSE_APPLY_STATE;
  courses: Courses[];
}

export interface Courses {
  id: number;
  course_group_id: number;
  course_name: string;
  display_order: number;
  incentive_name: string;
  incentive_type: string;
  cost: number;
  capacity: number;
  cource_won_limit: number;
  won_count: number;
  course_apply_state: COURSE_APPLY_STATE;
}
export interface CoursesResponse {
  course_groups: CourseGroups[];
  owned_count: number;
}
// 	応募コース情報取得 API
export const getCourses = (
  campaignId: string,
  token: string
): axios.AxiosPromise<CoursesResponse> => {
  return Vue.$axios.get(
    `${baseUrl}/collection/v1/campaign/${campaignId}/courses/${token}`
  );
};

export enum CREATIVE_TYPE {
  Movie = "movie",
  Image = "image",
}

export enum INCENTIVE_TYPE {
  PointConnect = "point_connect",
  Url = "url",
  InKind = "in_kind",
}

export interface RequestResult {
  course_id: number;
  course_name: string;
  course_group_name: string;
  won: boolean;
  incentive_name: string;
  incentive_type: INCENTIVE_TYPE;
  incentive_url: string;
  grant_point: number;
  owned_count: number;
  lottery_creative_id: number;
  lottery_creative_name: string;
  lottery_creative_type: CREATIVE_TYPE;
  lottery_creative_url: string;
  result_top_creative_id: number;
  result_top_creative_name: string;
  result_top_creative_type: CREATIVE_TYPE;
  result_top_creative_url: string;
  result_bottm_creative_id: number;
  result_bottm_creative_name: string;
  result_bottm_creative_type: CREATIVE_TYPE;
  result_bottom_creative_url: string;
}

// 応募 API
export const postRequest = (
  campaignId: string,
  token: string,
  courseId: number
): axios.AxiosPromise<RequestResult> => {
  return Vue.$axios.post(`${baseUrl}/collection/v1/request`, {
    campaign_id: campaignId,
    token: token,
    course_id: courseId,
  });
};

export interface CollectHistoryResponse {
  id: number;
  collect_count: number;
  collected_at: string;
  serial_code: string;
}

export interface CollectHistoies {
  collect_history: CollectHistoryResponse[];
}

// 貯める履歴取得 API
export const getCollectHistory = (
  campaignId: string,
  token: string
): axios.AxiosPromise<CollectHistoies> => {
  return Vue.$axios.get(
    `${baseUrl}/collection/v1/collect/history/${campaignId}/${token}`
  );
};

// 応募履歴取得 API
export interface RequestHistoryResponse {
  request_id: number;
  course_id: number;
  won: boolean;
  point: number;
  url: string;
  use_count: number;
  request_at: string;
  course_group_id: number;
  course_name: string;
  course_group_name: string;
  incentive_type: string;
  incentive_url: string;
  incentive_name: string;
}
export interface RequestHistoies {
  request_history: RequestHistoryResponse[];
}
export const getRequestHistory = (
  campaignId: string,
  token: string
): axios.AxiosPromise<RequestHistoies> => {
  return Vue.$axios.get(
    `${baseUrl}/collection/v1/request/history/${campaignId}/${token}`
  );
};

// 行動ログ API
export const postActionLog = (
  campaignId: string,
  token: string,
  serialCode: string,
  courseId: string | null,
  actionType: string
): axios.AxiosPromise<any> => {
  return Vue.$axios.post(`${baseUrl}/common/v1/action_log`, {
    campaign_id: campaignId,
    token: token,
    serial_code: serialCode,
    course_id: courseId,
    action_type: actionType,
  });
};
